<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    import Swal from 'sweetalert2';
    export let isLoggedIn = false;
    import LoginHeader from './LoginHeader.svelte';
    export let trainerData = {};
    import axios from 'axios';
    export let isResetMode = false;
    export let lang = '';
    let selLang;
    let email = '';
    let email_ = '';
    let password = '';
    let emailToReset = '';
    $: email = email_.toLowerCase();

    async function trainerLogin() {
        console.log('logging in');
        const url = `/trener/login`;
        const data = {
            login: email,
            password,
        };

        try {
            // console.log(data);
            const res = await axios({
                method: 'POST',
                url,
                data,
            });
            if (res.status === 200) {
                console.log(' incoming data', res.data);
                Object.assign(trainerData, res.data.data);
                trainerData.email = email;
                // console.log(trainerData);
                console.log(trainerData);
                rememberLogin();
                isLoggedIn = true;
            } else {
                console.log('stth wrong');
            }
        } catch (err) {
            Swal.fire(err.response.data.message);
        }
    }
    function rememberLogin() {
        let sessionStart = Date.now();
        localStorage.setItem(
            'sessionActivatedAt',
            JSON.stringify(sessionStart)
        );
        localStorage.setItem('trainerDataCache', JSON.stringify(trainerData));
    }
    async function resetPass() {
        const url = 'trener/sendresetpassemail';
        const data = {
            email: emailToReset.toLowerCase(),
        };

        try {
            const res = await axios({
                method: 'POST',
                url,
                data,
            });
            if (res.status === 200) {
                Swal.fire('Ok! Teraz sprawdź maila.');
            } else {
                Swal.fire(res.data.message);
            }
        } catch (err) {
            Swal.fire(err.response.data.message);
        }
    }
</script>

<div class="login__container">
    <LoginHeader {lang} />

    <div class="login__main">
        <div class="color-bar" />
        <form class="login__form">
            <h class="heading-secondary heading-secondary--darker">
                {texts[lang].login_prompt}
            </h>
            <div class="login__wrap">
                <!-- <label for="email">Adres email</label> -->
                <input
                    bind:value={email_}
                    id="email"
                    type="email"
                    name="email"
                    placeholder="email@gmail.com"
                />
            </div>
            <div class="login__wrap">
                <input
                    bind:value={password}
                    id="password"
                    type="password"
                    name="password"
                    placeholder="password"
                />
            </div>
            <div class="login__wrap">
                <!-- <form> -->
                <button class="button" on:click|preventDefault={trainerLogin}>
                    <span class="button-text__main"
                        >{texts[lang].login_confirm}</span
                    >
                </button>
                <!-- </form> -->
            </div>
            <div class="login__wrap">
                <!-- <div> -->
                <p class="p--italic">
                    {texts[lang].forgot_pass}
                    <button
                        class="button--italic"
                        on:click|preventDefault={() => {
                            isResetMode = true;
                        }}
                    >
                        <span class="p--italic">{texts[lang].click_here}</span>
                    </button>
                </p>
            </div>

            <div class="login__wrap login__wrap--column">
                {#if isResetMode}
                    <input
                        bind:value={emailToReset}
                        id="emailtoreset"
                        type="email"
                        name="emailtoreset"
                        placeholder="email@gmail.com"
                        class="input--link"
                    />
                    <button
                        class="button margin-reset"
                        on:click|preventDefault={resetPass}
                    >
                        <span class="button-text__main">{texts[lang].send}</span
                        >
                    </button>
                {/if}
            </div>
            <div class="login__wrap">
                <h class="p--italic">{texts[lang].languages}</h>
            </div>
            <div>
                <select
                    bind:value={selLang}
                    name="language"
                    id="select-language"
                    class="select-language"
                >
                    <option value="pl" class="select-item">
                        {texts[lang].languages_polish}
                    </option>
                    <option value="eng" class="select-item">
                        {texts[lang].languages_english}
                    </option>
                </select>
                <button
                    class="btn btn__smaller"
                    on:click|preventDefault={() => {
                        lang = selLang;
                    }}
                >
                    {texts[lang].languages_update}
                </button>
            </div>
        </form>
    </div>
</div>
